"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useQuantityPicker = useQuantityPicker;
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectDestructuringEmpty"));

var _react = _interopRequireWildcard(require("react"));

var _ = require("..");

var _ButtonRaw = _interopRequireDefault(require("../ButtonRaw"));

var _InputRaw = _interopRequireDefault(require("../InputRaw"));

var _Box = _interopRequireDefault(require("../Box"));

var _SelectNative = _interopRequireDefault(require("../SelectNative"));

var __jsx = _react["default"].createElement;
var useLayoutEffect = typeof window === "object" ? _react.useLayoutEffect : _react.useEffect;
var defaults = {
  $buttonDecrease: {
    __type: _ButtonRaw["default"],
    __children: "-"
  },
  $buttonIncrease: {
    __type: _ButtonRaw["default"],
    __children: "+"
  },
  $root: function $root(_ref) {
    var focused = _ref.focused;
    return {
      position: "relative",
      display: "inline-flex",
      verticalAlign: "top",
      overflow: "hidden",
      flexDirection: "row"
    };
  },
  $input: function $input(_ref2) {
    (0, _objectDestructuringEmpty2["default"])(_ref2);
    return {
      __type: _InputRaw["default"],
      textAlign: "center"
    };
  },
  $select: function $select() {
    return {
      __type: _SelectNative["default"],
      __props: {
        allowEmpty: false
      }
    };
  }
};

function useQuantityPicker() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      defaultValue = props.defaultValue,
      _props$maxValue = props.maxValue,
      maxValue = _props$maxValue === void 0 ? 999 : _props$maxValue,
      _props$selectOptionsA = props.selectOptionsAmount,
      selectOptionsAmount = _props$selectOptionsA === void 0 ? 19 : _props$selectOptionsA,
      onChange = props.onChange;

  var _useState = (0, _react.useState)(defaultValue || step),
      amount = _useState[0],
      setAmount = _useState[1];

  var _useState2 = (0, _react.useState)(defaultValue || step),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      inputFocusedAfterSelectingMore = _useState3[0],
      setInputFocusedAfterSelectingMore = _useState3[1];

  var inputRef = (0, _react.useRef)(null);

  var setValue = function setValue(number) {
    var newVal = number;

    if (isNaN(newVal)) {
      newVal = 0;
    }

    newVal = Math.max(newVal, step);
    newVal = Math.min(newVal, maxValue); // Check if multiple of step

    var rest = newVal % step;

    if (rest != 0) {
      newVal = newVal - rest;
    }

    setAmount(newVal);
    setInputValue(newVal);

    if (newVal !== amount && onChange) {
      onChange(newVal);
    }
  };

  var isMin = amount === step;
  var isMax = amount === maxValue - maxValue % step;
  var buttonIncrementProps = {
    onClick: function onClick() {
      setValue(amount + step);
    },
    disabled: isMax
  };
  var buttonDecrementProps = {
    onClick: function onClick() {
      setValue(amount - step);
    },
    disabled: isMin
  };
  var inputProps = {
    value: inputValue,
    onChange: function onChange(val) {
      setInputValue(val);
    },
    onBlur: function onBlur() {
      setValue((0, _parseInt2["default"])(inputValue));
      setInputFocusedAfterSelectingMore(false);
    },
    inputRef: inputRef
  };
  useLayoutEffect(function () {
    if (inputFocusedAfterSelectingMore) {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  }); // select

  var selectOptions = [];

  for (var i = 1; i <= selectOptionsAmount; i++) {
    selectOptions.push("".concat(i * step));
  }

  var maxSelectAmount = selectOptionsAmount * step;
  var moreOption = "".concat(maxSelectAmount + step, "+");
  selectOptions.push(moreOption);
  var exceedsSelectRange = amount > maxSelectAmount || inputFocusedAfterSelectingMore;
  var selectProps = {
    options: selectOptions,
    value: exceedsSelectRange ? moreOption : "".concat(amount),
    onChange: function onChange(val) {
      if (val === moreOption) {
        setInputValue("");
        setInputFocusedAfterSelectingMore(true); // inputRef.current.focus();
      } else {
        setValue((0, _parseInt2["default"])(val));
      }
    },
    label: "Quantity",
    placeholder: "Quantity"
  };
  var ret = {
    // inputFocusedAfterSelectingMore,
    exceedsSelectRange: exceedsSelectRange,
    buttonIncrementProps: buttonIncrementProps,
    buttonDecrementProps: buttonDecrementProps,
    inputProps: inputProps,
    selectProps: selectProps,
    amount: amount,
    isMax: isMax,
    isMin: isMin,
    setAmount: setValue,
    reset: function reset() {
      setValue(-1);
    }
  };
  return (0, _objectSpread2["default"])({}, ret, {
    counterProps: {
      controller: ret
    }
  });
}

function QuantityPicker$(props) {
  var _props$sx = props.sx,
      sx = _props$sx === void 0 ? {} : _props$sx;
  var controller;

  if (props.controller) {
    controller = props.controller;
  } else {
    controller = useQuantityPicker(props);
  }

  var _useState4 = (0, _react.useState)(false),
      focused = _useState4[0],
      setFocused = _useState4[1];

  var state = {
    focused: focused
  };
  sx = typeof sx === "function" ? sx(state) : sx;

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  var rootCss = typeof customSx.$root === "function" ? customSx.$root(state) : customSx.$root;

  var onFocus = function onFocus(e) {
    setFocused(true);
  };

  var onBlur = function onBlur(e) {
    setFocused(false);
  };

  var buttonDecrease;
  var buttonIncrease;

  if (customSx.$buttonDecrease !== null) {
    buttonDecrease = (0, _.createElement)((0, _.getElementSpec)(customSx.$buttonDecrease, defaults.$buttonDecrease, state, (0, _objectSpread2["default"])({
      onFocus: onFocus,
      onBlur: onBlur
    }, controller.buttonDecrementProps), "-"));
  }

  if (customSx.$buttonIncrease !== null) {
    buttonIncrease = (0, _.createElement)((0, _.getElementSpec)(customSx.$buttonIncrease, defaults.$buttonIncrease, state, (0, _objectSpread2["default"])({
      onFocus: onFocus,
      onBlur: onBlur
    }, controller.buttonIncrementProps), "+"));
  }

  var input = (0, _.createElement)((0, _.getElementSpec)(customSx.$input, defaults.$input, state), (0, _objectSpread2["default"])({
    type: "number",
    onFocus: onFocus,
    onBlur: onBlur
  }, controller.inputProps));
  var select = (0, _.createElement)((0, _.getElementSpec)(customSx.$select, defaults.$select, state), (0, _objectSpread2["default"])({
    onFocus: onFocus,
    onBlur: onBlur
  }, controller.selectProps));
  return (0, _.jsx)(_Box["default"], {
    sx: css
  }, (0, _.jsx)(_Box["default"], {
    sx: [{
      display: "flex",
      flexDirection: "row"
    }, defaults.$root(state), rootCss]
  }, buttonDecrease, controller.exceedsSelectRange && input, !controller.exceedsSelectRange && select, buttonIncrease));
}

var _default = QuantityPicker$;
exports["default"] = _default;